import { useState, useEffect } from "react";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import "../styles/sideBar.css";

export default function NotePad({ isToogle }) {
  const week = [
    { name: "Poniedziałek", short: "Pon" },
    { name: "Wtorek", short: "Wt" },
    { name: "Środa", short: "Śr" },
    { name: "Czwartek", short: "Czw" },
    { name: "Piątek", short: "Pt" },
    { name: "Sobota", short: "Sob" },
    { name: "Niedziela", short: "Ndz" },
    { name: "Dodatkowe", short: "Dod" },
  ];

  const [actualDay, setActualDay] = useState(week[0]);
  const [notes, setNotes] = useState({});
  const [text, setText] = useState("");

  useEffect(() => {
    const getNotes = onSnapshot(doc(db, "notes", "admin-note"), (snapshot) => {
      setNotes(snapshot.data());
    });
  }, []);

  useEffect(() => {
    const currentText = notes?.[actualDay?.short]?.text || "";
    setText(currentText);
  }, [notes, actualDay]);

  const noteSet = async () => {
    const currentText = notes?.[actualDay?.short]?.text || "";
    if (text.trim() !== currentText.trim()) {
      try {
        await updateDoc(doc(db, "notes", "admin-note"), { [`${actualDay.short}.text`]: text });
      } catch (error) {
        console.error("Błąd przy aktualizacji notatki:", error);
      }
    }
  };

  return (
    <div className={isToogle ? "side-toogle-margin" : "side-margin"} style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "column", minHeight: "100vh", overflowY: "scroll", gap: "15px", paddingBottom: "20px"})}>
      <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", width: "100%", marginTop: "20px", marginBottom: "20px"})}>
        <h3 style={({fontWeight: "bold", fontSize: "15px", fontStyle: "italic", letterSpacing: "-0.3px", textDecoration: "underline"})}>{actualDay ? actualDay?.name : ""}</h3>
      </div>
      <div style={({display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "80%"})}>
        {week.map((d) => (
          <div key={d.short} onClick={() => setActualDay(d)} style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "7px", cursor: "pointer"})}>
            <h3 style={({fontWeight: "bold", fontSize: "12px", color: actualDay?.short === d?.short ? "#0045c7" : "rgb(30,30,30)", transition: "0.6s", fontStyle: "italic", letterSpacing: "-0.3px"})}>{d?.short}</h3>
          </div>
        ))}
      </div>
      <hr style={({width: "85%", border: "1px solid rgb(0,0,0,0.03)"})}/>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={noteSet}
        style={({width: "80%", border: "1px solid rgb(200,200,200)", borderRadius: "5px", minHeight: "750px", padding: "20px", fontSize: "16px", resize: "none"})}
      />
    </div>
  );
}
